import moment from "moment";
import TextField from "../../../../components/fields/textField/TextField.vue";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { FeriadoCivilService } from "../../../../services/FeriadoCivilService";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import EditarFeriado from "./editarFeriado/EditarFeriado.vue"
import { date } from "date-typescript-library";
export default {
  name: "AtribuirFeriadosCivis",

  components: {
    TextField,
    SelectField,
    EditarFeriado
  },

  data: () => ({
    form: {},

    page: 1,
    pageCount: 0,
    totalItems:0,

    selected:[],
    editarFeriadoDialog:false,

    feriadosAdicionar: [],
    options:{
     feriados:[

     ]
    },

    headers: [
      { text: "Feriado", value: "nome", width: 500, sortable: false },
      { text: "Data", value: "data", width: 300, sortable: false },
      { text: "Ações", value: "actions", sortable: false },
    ],
    items: [],

    loading: {
      table: false,
      btn: false,
    }
  }),

  beforeMount() {
    this.$router.push('/configuracoes/atribuir-feriados');
    this.getFeriados();
    this.getFeriadosPadrao()
  },

  filters: {
    localeDate(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },

  watch:{
    // feriadosAdicionar(value){

    //   if(this.feriadosAdicionar.length > 0){
    //     for (var key in this.options.feriados) {
    //       if(this.options.feriados[key].value == value){
    //         this.form.nomeFeriado = this.options.feriados[key].titulo;
    //         this.form.dataFeriado = this.options.feriados[key].data;
    //       } 
    //     }
    //     this.feriadosAdicionar = []
    //   }    
    // }
  },

  methods: {
    async getFeriados() {
      this.loading.table = true;
      const response = await FeriadoCivilService.getFeriados();
      this.items = response;
      this.loading.table = false;
    },

    async getFeriadosPadrao() {
      this.loading.table = true;
      const response = await FeriadoCivilService.getFeriadosPadrao();

      this.options.feriados = response.map((el) => {
        return {
          text: `${el.titulo} - ${el.dia}/${el.mes} `,
          titulo: el.titulo,
          data: `${el.mes}/${el.dia}/` + date('Y'),
          value: el.id,
        };
      });

      // this.options.feriados?.unshift({ text: "Selecione", value: "" });
    },

    prepareForm() {
      if (this.feriadosAdicionar.length > 0) {
        const formData = new FormData()
        this.feriadosAdicionar.forEach((value, index) =>{
          const result = this.options.feriados.find(x => x.value === value)
          formData.append(`feriados[${index}][nome]`, result.titulo);
          formData.append(`feriados[${index}][data]`, moment(result.data).format("YYYY-MM-DD"))
          formData.append(`feriados[${index}][id_tipo_feriado]`, 2);

        });



        return this.createFeriado(formData);
      }
      return SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async createFeriado(formData) {
      this.loading.btn = true;
      const response = await FeriadoCivilService.postFeriado(formData);
      if (response) {
        this.$refs.form.reset();
      }
      this.loading.btn = false;
      this.getFeriados();
      return response;
    },

    editarFeriado(item){
      this.selected = {id:item.id, nome:item.nome, data:item.data}
      this.editarFeriadoDialog = true;
    },

    closeEditarFeriado(){
      this.getFeriados();
      this.editarFeriadoDialog = false
    },

    async deleteFeriado(id) {
      this.loading.table = true;
      await FeriadoCivilService.deleteFeriado(id);
      this.getFeriados();
      this.loading.table = false;
    },
  },
};